<template>
    <aside id="menu">
        <div id="navigation">
            <div class="profile-picture">
                <a href="javascript:void(0)">
                    <img src="../../assets/images/user.png" class="img-circle m-b" alt="logo">
                </a>
                <div class="stats-label text-color" v-if="isUserLoaded">
                    <span class="font-extra-bold font-uppercase">{{getUser.name}}</span>

                    <p>
                        <small class="text-muted">{{getUser.email}}</small>
                    </p>
                </div>
            </div>
            <ul class="nav" id="side-menu">
                <li v-for="(m) in menu" :key="m.title" :class="{'active': isActive(m.route)}"
                    v-if="$can('manage', m.name)">
                    <router-link v-if="!m.noRedirect" :class="m.noRedirect ? '' : 'navigateLink'" tag="a" :to="m.route">
                        <i v-if="m.icon" :class="m.icon"></i> <span class="nav-label">{{m.title}}</span>
                    </router-link>
                    <a v-if="m.child" href="javascript:void(0)" :class="m.noRedirect ? '' : 'navigateLink'">
                        <i v-if="m.icon" :class="m.icon"></i> <span class="nav-label">{{m.title}}</span><span
                        class="fa arrow"></span></a>
                    <ul v-if="m.child" :class="'nav nav-second-level collapse ' + (isActive(m.route) ? 'in' : '')">
                        <li v-for="(c) in m.child" :key="c.title" v-if="$can('manage', c.name)"
                            :class="{'active':  isActive(c.route)}">
                            <router-link v-if="!c.noRedirect" tag="a" :to="c.route"
                                         :class="c.noRedirect ? '' : 'navigateLink'">{{c.title}}
                            </router-link>
                            <a v-if="c.child" href="javascript:void(0)" :class="c.noRedirect ? '' : 'navigateLink'">
                                {{c.title}}<span class="fa arrow"></span></a>
                            <ul v-if="c.child" :class="'nav nav-third-level collapse ' + (isActive(c.route) ? 'in' : '')">
                                <li v-for="(t) in c.child" :key="t.title" v-if="$can('manage', t.name)">
                                    <router-link v-if="!t.noRedirect" tag="a" :to="t.route" class="navigateLink">
                                        {{t.title}}
                                    </router-link>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </aside>
</template>
<script>
    import {mapGetters} from 'vuex'
    import {Can} from '@casl/vue'
    import * as routes from '../../router/routes'
    import {APP_ADMIN_USER} from "../../router/routes";

    export default {
        components: {
            Can
        },
        data() {
            return {
                usuario: '',
                menu: [
                    {
                        name: routes.DASHBOARD.name,
                        route: routes.DASHBOARD.route,
                        title: routes.DASHBOARD.desc,
                    },
                    {
                        name: routes.USER.name,
                        route: routes.USER.route,
                        title: routes.USER.desc,
                        noRedirect: true,
                        child: [
                            {
                                name: routes.USER_LIST.name,
                                route: routes.USER_LIST.route,
                                title: routes.USER_LIST.desc,
                            },
                            {
                                name: routes.USER_NEW.name,
                                route: routes.USER_NEW.route,
                                title: routes.USER_NEW.desc,
                            },
                        ]
                    },
                    {
                        name: routes.APP_ADMIN_USER.name,
                        route: routes.APP_ADMIN_USER.route,
                        title: routes.APP_ADMIN_USER.desc,
                        noRedirect: true,
                        child: [
                            {
                                name: routes.APP_ADMIN_USER_LIST.name,
                                route: routes.APP_ADMIN_USER_LIST.route,
                                title: routes.APP_ADMIN_USER_LIST.desc,
                            },
                            {
                                name: routes.APP_ADMIN_USER_NEW.name,
                                route: routes.APP_ADMIN_USER_NEW.route,
                                title: routes.APP_ADMIN_USER_NEW.desc,
                            },
                        ]
                    },
                    {
                        name: routes.HOTEL.name,
                        route: routes.HOTEL.route,
                        title: routes.HOTEL.desc,
                        noRedirect: true,
                        child: [
                            {
                                name: routes.HOTEL_LIST.name,
                                route: routes.HOTEL_LIST.route,
                                title: routes.HOTEL_LIST.desc,
                            },
                            {
                                name: routes.HOTEL_NEW.name,
                                route: routes.HOTEL_NEW.route,
                                title: routes.HOTEL_NEW.desc,
                            },
                        ]
                    },
                    {
                        name: routes.VEHICLE.name,
                        route: routes.VEHICLE.route,
                        title: routes.VEHICLE.desc,
                        noRedirect: true,
                        child: [
                            {
                                name: routes.VEHICLE_LIST.name,
                                route: routes.VEHICLE_LIST.route,
                                title: routes.VEHICLE_LIST.desc,
                            },
                            {
                                name: routes.VEHICLE_NEW.name,
                                route: routes.VEHICLE_NEW.route,
                                title: routes.VEHICLE_NEW.desc,
                            },
                        ]
                    },
                    {
                        name: routes.GUEST.name,
                        route: routes.GUEST.route,
                        title: routes.GUEST.desc,
                        noRedirect: true,
                        child: [
                            {
                                name: routes.GUEST_LIST.name,
                                route: routes.GUEST_LIST.route,
                                title: routes.GUEST_LIST.desc,
                            },
                            {
                                name: routes.GUEST_NEW.name,
                                route: routes.GUEST_NEW.route,
                                title: routes.GUEST_NEW.desc,
                            },
                        ]
                    }
                ]
            }
        },
        methods: {
            isActive(input) {
                const paths = Array.isArray(input) ? input : [input];
                return paths.some(path => {
                    return this.$route.path.indexOf(path) >= 0 // current path starts with this path string
                })
            },
            initializeMenu(){
                if (this.isUserSuccess) {
                    setTimeout(() => {
                        $('#side-menu').metisMenu();
                    }, 900)
                }
            }
        },
        computed: {
            ...mapGetters([
                'getUser',
                'isUserLoaded',
                'isUserSuccess'
            ]),
        },
        watch: {
            isUserSuccess: function () {
                this.initializeMenu();
            }
        },
        mounted() {
            this.initializeMenu();
            if ($('body').hasClass('sidebar-scroll')) {
                $('#navigation').slimScroll({
                    height: '100%',
                    opacity: 0.3,
                    size: 0,
                    wheelStep: 5
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/layout/Sidebar.vue